export default {
  unitOfMeasureCollection: [],
};
